import React from "react";
import { Sparkles } from "lucide-react";
import { useT } from "../../lib/i18n";
import { matchColor } from "../ListingCard";

export const DetailMatchBlock = ({ listing, user }) => {
  const { t } = useT();
  const mc = matchColor(listing.match_score);
  const breakdown = listing.match_breakdown || [];
  return (
    <div className="mt-6 overflow-hidden rounded-3xl border border-border bg-brandblue-light/40 p-6">
      <div className="flex items-center gap-3">
        <span className={`flex h-12 w-12 items-center justify-center rounded-2xl text-base font-extrabold ${mc.bg} ${mc.text}`}>
          {listing.match_score}
        </span>
        <div>
          <h2 className="font-display text-lg font-bold text-navy">{t("detail.match.title")}</h2>
          <p className="text-sm text-slate-500">
            {user ? `${listing.match_score}% ${t("common.match")}` : t("detail.loginForScore")}
          </p>
        </div>
      </div>
      {breakdown.length > 0 && (
        <ul className="mt-4 space-y-2">
          {breakdown.map((b, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
              <Sparkles size={15} className="mt-0.5 shrink-0 text-brandblue" />
              <span>{typeof b === "string" ? b : b.label || b.reason || JSON.stringify(b)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
